<template>
  <div v-if="!isLoading">
    <div class="mt-4 d-flex align-items-start justify-content-between">
      <h1 class="page-title">{{ $t('Dashboard') }}</h1>
    </div>

    <div class="row">

      <div class="col-lg-3 col-md-3 col-sm-12 mt-4 mb-4">
        <card-component
          :value="card1Value"
          background-color="main-color"
          title="dashboard.card.title.operations.ongoing"/>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 mt-4 mb-4">
        <card-component
          :value="Intl.NumberFormat().format((card2Value / 100).toFixed(0)) + ' €'"
          background-color="main-color"
          title="dashboard.card.title.ca.ht"/>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 mt-4 mb-4">
        <card-component
          :value="Intl.NumberFormat().format((card3Value / 100).toFixed(0)) + ' €'"
          background-color="main-color"
          title="dashboard.card.title.total.stock"/>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 mt-4 mb-4">
        <card-component
          :value="card4Value"
          background-color="secondary-color"
          title="dashboard.card.title.tasks.todo"/>
      </div>

    </div>

    <template v-for="alert in taskAlerts">
      <b-alert :variant="alert.style" class="my-1" dismissible show @dismissed="modifyAlertDate(alert.tasks)">
        <b-link v-if="alert.tasks.length === 1" @click="goToTask(alert.tasks)">
          {{ alert.element + ' ' + $t(alert.content) }}
        </b-link>
        <div v-else> {{ alert.element + ' ' + $t(alert.content) }}</div>
      </b-alert>
    </template>

    <dashboard-tasks-component/>

  </div>
</template>

<script>

import api from "../../services/api";
import CardComponent from "../../components/b122/CardComponent";
import DashboardTasksComponent from "./components/DashboardTasksComponent";

export default {
  name: "DashboardEstateAgent",

  components: {
    CardComponent,
    DashboardTasksComponent
  },

  data() {
    return {
      isLoading: false,
      startOfYear: null,
      endOfYear: null,
      card1Value: null,
      card2Value: null,
      card3Value: null,
      card4Value: null,
      isFirstConnexion: null,
      taskAlerts: []
    }
  },

  mounted() {
    this.startOfYear = new Date(new Date().getFullYear(), 0, 1).getTime()
    this.endOfYear = new Date(new Date().getFullYear() + 1, 0, 1).getTime()
    this.fetchData()
  },

  methods: {

    fetchData() {
      this.fetchDashboardData()
      this.fetchTaskAlerts()
    },

    fetchDashboardData() {
      this.isLoading = true
      let formData = new FormData()
      formData.append('startOfYear', this.startOfYear)
      formData.append('endOfYear', this.endOfYear)

      api({
        method: 'POST',
        url: '/dashboard/getDashboardEstateAgentInfos',
        data: formData
      })
        .then(response => {
          this.card1Value = response.data.card1Value.toString()
          this.card2Value = response.data.card2Value.toString()
          this.card3Value = response.data.card3Value.toString()
          this.card4Value = response.data.card4Value.toString()
          this.isFirstConnexion = response.data.isFirstConnexion
          this.isLoading = false
          if (this.isFirstConnexion) {
            this.showOnBoardingModal()
          }

        })
    },

    showOnBoardingModal() {
      this.$bvModal.show('first-connexion-modal')
    },


    async fetchTaskAlerts() {
      this.isLoading = true
      await api
        .get(`/operationTask/getAlertsForUser`)
        .then(response => {
          this.taskAlerts = response.data
          this.isLoading = false
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'Dashboard'
            })
          }
        })
    },

    goToTask(tasks) {
      if (tasks.length === 1) {
        this.$router.push({
          name: 'OperationTaskShow',
          params: {
            operationTaskId: tasks[0]
          }
        })
      } else {
        this.currentSection = 3
      }
    },

    async modifyAlertDate(tasksId) {
      let today = new Date()
      today.setHours(0, 0, 0)
      let tomorrow = today.getTime() + (24 + 9) * 60 * 60 * 1000
      for (const id of tasksId) {
        let data = new FormData()
        data.append('alertDate', tomorrow.toString())
        let url = '/operationTask/updateAlertDate/' + id

        await api({
          method: 'POST',
          url: url,
          data: data
        })
          .then(() => {
            this.$router.push({
              name: 'Dashboard'
            })
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'Dashboard'
              })
            }
          })
      }
    },

  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dashboard/DashboardEstateAgent.vue